import React from 'react';
import './style.scss';
import { DefaultIcon, Delete as DeleteIcon, Pencil as PencilIcon } from '../../../atoms/icons';

interface Props {
    id: string | undefined;
    deleteIcon?: React.ReactElement<DefaultIcon> | undefined;
    editIcon?: React.ReactElement<DefaultIcon> | undefined;
    name: string;
    email: string;
    phone: string;
    position: string;
    role: string;
}
const Contact: React.FC<Props> = (props) => {
  const {
    id, name, email, phone, position, role,
    editIcon = <PencilIcon width={20} color="black" />,
    deleteIcon = <DeleteIcon width={18} color="black" />,
  } = props;
  return (
    <div className="card-contact-container" id={id}>
      <div className="contact-container">
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-start">
            <div className="contact-profil">
              <div className="icon-name">
                <div className="mt-1">{name.slice(0, 1)}</div>
              </div>
            </div>
            <div className="contact-header">
              <div className="contact-name">
                {name}
              </div>
              <div className="contact-email">
                {email}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end icon">
            <div className={deleteIcon ? 'me-2' : 'd-none'}>
              {deleteIcon}
            </div>
            <div style={editIcon ? { marginTop: '1px' } : {}} className={editIcon ? '' : 'd-none'}>{editIcon}</div>
          </div>
        </div>

        <div className="phone-contact">
          <div className=" label">
            PHONE NUMBER:
          </div>
          <div className="contact">
            {phone}
          </div>
        </div>

        <div className="position-contact">
          <div className="label">
            POSITION:
          </div>
          <div className="contact">
            {position}
          </div>
        </div>

        <div className="role-contact">
          <div className="label two">
            ROLE:
          </div>
          <div className="contact">
            {role}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
